import { render } from "./Quill.vue?vue&type=template&id=0ce5957a&scoped=true"
import script from "./Quill.vue?vue&type=script&lang=js"
export * from "./Quill.vue?vue&type=script&lang=js"

import "./Quill.vue?vue&type=style&index=0&id=0ce5957a&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ce5957a"]])

export default __exports__